import { useState, useContext } from "react"
import { bool } from "prop-types"
import { ChromePicker } from "react-color"
import ReactSlider from "react-slider"
import { Spatialise } from "./Spatialise"
import { Global } from "../classes/global"
import { Player } from "../classes/player"
import { ParentPlane } from "./3DUIElements/ParentPlane"
import { XRPointerInteractions } from "../3D/xrPointerInteractions"

function Parent({ parent }: { parent: string }) {
	// This component is conceptual and won't directly render in React.
	// Its props are used by Spatialise to create a 3D color picker in BabylonJS.
	return null
}
function Button({
	buttonLabel,
	btnImageUrl,
	btnImageUrl1,
}: {
	buttonLabel?: string
	btnImageUrl?: string
	btnImageUrl1?: string
}) {
	// This component is conceptual and won't directly render in React.
	// Its props are used by Spatialise to create a 3D color picker in BabylonJS.
	return null
}
function RadioButton({
	group,
	imageURL,
	onCheckChanged,
	isChecked,
}: {
	group?: string
	imageURL?: string
	onCheckChanged?: any
	isChecked?: boolean
}) {
	// This component is conceptual and won't directly render in React.
	// Its props are used by Spatialise to create a 3D color picker in BabylonJS.
	return null
}
function Text({
	text,
	fontSize,
	fontWeight,
}: {
	text: string
	fontSize: number
	fontWeight: string
}) {
	// This component is conceptual and won't directly render in React.
	// Its props are used by Spatialise to create a 3D color picker in BabylonJS.
	return null
}

function DialPicker({
	onAngleChanged,
	dialPicker,
}: {
	onAngleChanged: (angle: number) => void
	dialPicker: boolean
}) {
	// This component is conceptual and won't directly render in React.
	// Its props are used by Spatialise to create a 3D dial picker in BabylonJS.
	return null
}
function ColorPicker({
	onColorChanged,
	colourPicker,
}: {
	onColorChanged: (color: BABYLON.Color3) => void
	colourPicker: boolean
}) {
	// This component is conceptual and won't directly render in React.
	// Its props are used by Spatialise to create a 3D color picker in BabylonJS.
	return null
}
function Slider({
	min,
	max,
	value,
	onChange,
	slider,
}: {
	min: number
	max: number
	value: number
	onChange: any
	slider: boolean
}) {
	// This component is conceptual and won't directly render in React.
	// Its props are used by Spatialise to create a 3D slider in BabylonJS.
	return null
}
function FabricUploadButton(url: string) {
	//document.getElementById("rd1")!.click()
	//document.getElementById("btnUpload")!.click()
	Player.setFabric(url)
}
function GarmentToggleButton() {
	document.getElementById("btnDisplayOutfit")!.click()
}

function ColourSlider(value: any) {
	if (process.env.REACT_APP_VR_PREVIEW_FLAG == "true") {
		if (document.getElementById("customiseButton") != null) {
			document.getElementById("customiseButton")!.click()
		}
	}
	if (document.getElementById("rd3") != null) {
		document.getElementById("rd3")!.click()
		Global.spatialSliderValue(value)
	}

	return value
}

function ColourWheelValue(value: any) {
	if (process.env.REACT_APP_VR_PREVIEW_FLAG == "true") {
		if (document.getElementById("customiseButton") != null) {
			document.getElementById("customiseButton")!.click()
		}
	}
	if (document.getElementById("rd3") != null) {
		document.getElementById("rd3")!.click()
		Global.spatialColourValueChange(value)
	}

	return value
}
function DialValue(value: any) {
	if (process.env.REACT_APP_VR_PREVIEW_FLAG == "true") {
		if (document.getElementById("customiseButton") != null) {
			document.getElementById("customiseButton")!.click()
		}
	}
	if (document.getElementById("rd2") != null) {
		document.getElementById("rd2")!.click()
		Global.spatialDialValueChange(value)
	}

	return value
}

function OpacitySlider(value: any) {
	ParentPlane.sliderChangeOpacity(value)
	return value
}
function SizeSlider(value: any) {
	ParentPlane.sliderChangeSize(value)
	return value
}

export function SpatialUI() {
	const [color, setColor] = useState("#fff")
	const [slideValue, setSlideValue] = useState(0)
	function handleSelectionChange(value: any) {
		console.log("Dropdown selection:", value)
	}

	function handleColorChange(colour: any) {
		console.log("New color selected:", colour.hex)

		setColor(colour)
	}

	const arrValues = [
		{ key: "None", value: "None" },
		{ key: "Kitchenette", value: "Kitchenette" },
		{ key: "Sofa", value: "Sofa" },
		{ key: "Floor", value: "Floor" },
	] as any

	function onChange(e: React.ChangeEvent<HTMLSelectElement>) {}
	const handleSliderChange = (value: number) => {
		console.log("Slider value:", value)
	}
	const handleDialChange = (angle: number) => {
		console.log("Dial angle:", angle)
	}

	//Text
	const FabricHeading = "Fabric"
	const FabricText =
		"Select a fabric\nNote: You can upload an image using\nnon-spatial mode "
	const FabricText1 = "Drag and drop JPG or PNG"
	const HemHeading = "Hem"
	const HemText = "Colour"
	const HemText1 = "Shine"
	const AngleHeading = "Angle"
	const AngleText =
		"Drag the circle to the angle position\nfor your fabric texture"
	const ToggleText = "Display Outfit"
	//spatial - position={[0.4, 1.3, 1.3]} position={[-0.4, 1.3, 1.3]}
	//position={[0, 2.3, 7.5]}
	return (
		<>
			<Spatialise
				position={[0.4, 1.3, 1.3]}
				size={[0.5, 0.7]}
				colour="#FFFFFF80"
				accentColour1="#000000"
				grabbable={true}
			>
				<Parent parent="UI_parent" />
			</Spatialise>
			<Spatialise
				position={[-0.4, 1.3, 1.3]}
				size={[0.5, 0.7]}
				colour="#FFFFFF80"
				accentColour1="#000000"
				grabbable={true}
			>
				<Parent parent="UI_parent1" />
			</Spatialise>
			#Fabric Heading
			<Spatialise
				position={[-0.15, 0.25, -0.01]}
				colour="#000000"
				size={[0.15, 0.15]}
				parentID="UI_parent"
			>
				<Text text={FabricHeading} fontSize={300} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.01, 0.045, -0.01]}
				colour="#000000"
				size={[0.43, 0.43]}
				parentID="UI_parent"
			>
				<Text text={FabricText} fontSize={50} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.1, 0.3 - 0.18, -0.03]}
				size={[0.06, 0.06]}
				colour="#f58d2c"
				parentID="UI_parent"
			>
				<RadioButton
					group="fabric"
					imageURL="./assets/default_top.jpg"
					onCheckChanged={() => FabricUploadButton("./assets/default_top.jpg")}
					isChecked={false}
				/>
			</Spatialise>
			<Spatialise
				position={[0, 0.3 - 0.18, -0.03]}
				size={[0.06, 0.06]}
				colour="#f58d2c"
				parentID="UI_parent"
			>
				<RadioButton
					group="fabric"
					imageURL="./assets/top1.jpg"
					onCheckChanged={() => FabricUploadButton("./assets/top1.jpg")}
					isChecked={false}
				/>
			</Spatialise>
			<Spatialise
				position={[0.1, 0.3 - 0.18, -0.03]}
				size={[0.06, 0.06]}
				colour="#f58d2c"
				parentID="UI_parent"
			>
				<RadioButton
					group="fabric"
					imageURL="./assets/top2.jpg"
					onCheckChanged={() => FabricUploadButton("./assets/top2.jpg")}
					isChecked={false}
				/>
			</Spatialise>
			#Angle Heading
			<Spatialise
				position={[-0.15, -0.03, -0.01]}
				colour="#000000"
				size={[0.15, 0.15]}
				parentID="UI_parent"
			>
				<Text text={AngleHeading} fontSize={300} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.01, -0.235, -0.015]}
				colour="#000000"
				size={[0.43, 0.43]}
				parentID="UI_parent"
			>
				<Text text={AngleText} fontSize={50} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[0, -0.2, -0.03]}
				colour="#000000"
				accentColour1="#f58d2c"
				parentID="UI_parent"
			>
				<DialPicker
					onAngleChanged={(value: any) => {
						DialValue(value)
					}}
					dialPicker={true}
				/>
			</Spatialise>
			#Hem Heading
			<Spatialise
				position={[-0.15, -0.03, -0.01]}
				colour="#000000"
				size={[0.15, 0.15]}
				parentID="UI_parent1"
			>
				<Text text={HemHeading} fontSize={300} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.08, -0.06, -0.01]}
				colour="#000000"
				size={[0.09, 0.09]}
				parentID="UI_parent1"
			>
				<Text text={HemText} fontSize={300} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[0.14, -0.06, -0.01]}
				colour="#000000"
				size={[0.09, 0.09]}
				parentID="UI_parent1"
			>
				<Text text={HemText1} fontSize={300} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.08, -0.17, -0.03]}
				colour="#000000"
				scalerSize={0.19}
				parentID="UI_parent1"
			>
				<ColorPicker
					onColorChanged={(value: any) => {
						ColourWheelValue(value)
					}}
					colourPicker={true}
				/>
			</Spatialise>
			<Spatialise
				position={[0.13, -0.17, -0.03]}
				size={[0.05, 0.16]}
				parentID="UI_parent1"
				orientation="vertical"
				colour="#f58d2c"
				accentColour1="#000000"
			>
				<Slider
					min={0}
					max={100}
					value={10}
					onChange={(value: any) => {
						ColourSlider(value)
					}}
					slider={true}
				/>
			</Spatialise>
			#Toggle Banner
			<Spatialise
				position={[-0.15 / 2, 0.175, -0.01]}
				colour="#000000"
				size={[0.3, 0.3]}
				parentID="UI_parent1"
			>
				<Text text={ToggleText} fontSize={150} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[0, -0.44 + 0.6, -0.03]}
				size={[0.1, 0.1]}
				onButtonClick={() => GarmentToggleButton()}
				colour="#00000000"
				accentColour1="#00000000"
				parentID="UI_parent1"
			>
				<Button
					buttonLabel="Toggle"
					btnImageUrl="./assets/DisplayOutfit.svg"
					btnImageUrl1="./assets/HideOutfit.svg"
				/>
			</Spatialise>
		</>
	)
}
export function GeneralSettings() {
	const Heading = "General Settings"
	const SubHeading1 = "Opacity"
	const SubHeading2 = "Size"
	const SubHeading3 = "Anchor"

	return (
		<>
			<Spatialise
				position={[1, 1.3, 1.3]}
				size={[0.5, 0.7]}
				colour="#FFFFFF80"
				accentColour1="#000000"
				grabbable={false}
			>
				<Parent parent="UI_parent_settings" />
			</Spatialise>
			<Spatialise
				position={[0.001, 0.095, -0.001]}
				colour="#000000"
				size={[0.45, 0.45]}
				parentID="UI_parent_settings"
			>
				<Text text={Heading} fontSize={90} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.12, 0.125, -0.001]}
				colour="#000000"
				size={[0.2, 0.2]}
				parentID="UI_parent_settings"
			>
				<Text text={SubHeading1} fontSize={170} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.03, 0.11, -0.003]}
				size={[0.4, 0.07]}
				parentID="UI_parent_settings"
				orientation="horizontal"
				colour="#f58d2c"
				accentColour1="#000000"
			>
				<Slider
					min={0}
					max={100}
					value={50}
					onChange={(value: any) => {
						OpacitySlider(value)
					}}
					slider={true}
				/>
			</Spatialise>
			<Spatialise
				position={[-0.12, -0.05, -0.001]}
				colour="#000000"
				size={[0.2, 0.2]}
				parentID="UI_parent_settings"
			>
				<Text text={SubHeading2} fontSize={170} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[-0.03, -0.039, -0.003]}
				size={[0.4, 0.07]}
				parentID="UI_parent_settings"
				orientation="horizontal"
				colour="#f58d2c"
				accentColour1="#000000"
			>
				<Slider
					min={0}
					max={100}
					value={50}
					onChange={(value: any) => {
						SizeSlider(value)
					}}
					slider={true}
				/>
			</Spatialise>
			<Spatialise
				position={[-0.12, -0.22, -0.001]}
				colour="#000000"
				size={[0.2, 0.2]}
				parentID="UI_parent_settings"
			>
				<Text text={SubHeading3} fontSize={170} fontWeight="Bold" />
			</Spatialise>
			<Spatialise
				position={[0, -0.22, -0.003]}
				size={[0.1, 0.1]}
				onButtonClick={() => XRPointerInteractions.pannelsAnchor()}
				colour="#00000000"
				accentColour1="#00000000"
				parentID="UI_parent_settings"
			>
				<Button buttonLabel="Toggle" btnImageUrl="./assets/Anchor.svg" />
			</Spatialise>
		</>
	)
}

/* 
 Size silder
 duplicate the sider function
 */
